export function safeInitial(value: unknown, fallback = "A"): string {
  const normalized = String(value ?? "").trim();
  return (normalized[0] || fallback).toUpperCase();
}
